import { useEffect, useState } from 'react';
import { PageDisplayOption } from '../types/pageDispalyOptions.ts';


interface Props {
    pageDisplay: PageDisplayOption | undefined;
}

export function usePageDisplay({ pageDisplay }: Props) {
    const [page, setPage] = useState<number>(1);

    useEffect(() => {
        const flipPage = () => {
            setPage((prev) => prev === 1 ? 2 : 1); // Cycle through pages 1 and 2
        };

        if (pageDisplay?.key === 'alternating') {
            const interval = setInterval(flipPage, 10_000);
            return () => clearInterval(interval);
        } else {
            setPage(pageDisplay?.page ?? 1);
            return undefined;
        }
    }, [pageDisplay]);


    return {
        page,
    }
}
